import store from '@/store';
import { UtilityHelper } from './UtilityHelper';

interface StoredEvent {
    timestamp: number;
}

class AnalyticsHelper {
    private sentEvents: Record<string, StoredEvent> = {};
    private readonly STORAGE_KEY = 'sentAnalyticsEvents';
    private readonly EXPIRATION_TIME = 24 * 60 * 60 * 1000;

    constructor() {
        this.load();
        this.cleanup();
    }

    private load() {
        const saved = localStorage.getItem(this.STORAGE_KEY);
        this.sentEvents = saved ? JSON.parse(saved) : {};
    }

    private save() {
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.sentEvents));
    }

    private getEventHash(step: string): string | null {
        const userId = store.state.analyticsService.getUserId();
        if (!userId) return null;
        return `${userId}_${step}`;
    }

    private cleanup() {
        const now = Date.now();
        let changed = false;

        for (const [hash, event] of Object.entries(this.sentEvents)) {
            if (now - event.timestamp > this.EXPIRATION_TIME) {
                delete this.sentEvents[hash];
                changed = true;
            }
        }

        if (changed) this.save();
    }

    async sendStepEventOnce(step: string) {
        if (!store.state.analyticsReady) {
            await UtilityHelper.wait(() => store.state.analyticsReady === true);
        }

        const hash = this.getEventHash(step);
        const now = Date.now();

        if (
            hash &&
            this.sentEvents[hash] &&
            now - this.sentEvents[hash].timestamp < this.EXPIRATION_TIME
        ) {
            return;
        }

        store.state.analyticsService.sendStepEvent(step);

        if (hash) {
            this.sentEvents[hash] = { timestamp: now };
            this.save();
        }
    }

    clearCache() {
        this.sentEvents = {};
        this.save();
    }
}

export default new AnalyticsHelper();
